<template>
  <v-dialog
    v-model="dialog"
    scrollable
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card>
      <v-toolbar dark color="primary">
        <v-toolbar-title>
          {{
            notification._id
              ? $t('titles.global.updateModel', {
                  field: $tc('models.notification'),
                })
              : $t('titles.global.newAModel', {
                  field: $tc('models.notification'),
                })
          }}
        </v-toolbar-title>
        <v-spacer />
        <v-toolbar-items>
          <v-btn icon dark @click="cancel">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <v-container py-0>
          <v-layout row wrap>
            <v-flex d-flex xs12 px-2>
              <translation-field
                ref="title"
                v-model="notification.title"
                :label="$t('fields.global.title')"
                :required="true"
              />
            </v-flex>
            <v-flex d-flex xs12 px-2>
              <translation-field
                ref="text"
                v-model="notification.text"
                :label="$t('fields.global.text')"
                :required="false"
              />
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex md6 xs12 px-2>
              <v-autocomplete
                v-model="notification.sendType"
                v-validate="'required'"
                :readonly="!edit"
                :items="sendTypes"
                multiple
                :label="
                  $t('action.actions.select', {
                    field: $tc('fields.notifications.sendType'),
                  }) + ' (*)'
                "
                :clearable="edit"
                :data-vv-name="$t('fields.notifications.sendType')"
                :error-messages="
                  errors.collect($t('fields.notifications.sendType'))
                "
              />
            </v-flex>
            <v-flex md6 xs12 px-2>
              <v-datetime-picker
                v-model="datetime"
                :label="$t('fields.notifications.selectDateTime')"
              />
            </v-flex>
            <v-flex v-if="notification._id" xs12 px-2>
              <v-flex md6 xs12 px-2>
                <v-autocomplete
                  v-model="notification.type"
                  :readonly="!edit"
                  :items="types"
                  :label="
                    $t('action.actions.select', {
                      field: $tc('fields.global.type'),
                    }) + ' (*)'
                  "
                />
              </v-flex>
            </v-flex>
            <v-flex v-if="isAdmin" md6 xs12 px-2>
              <v-autocomplete
                v-model="notification.typeRemittent"
                v-validate="'required'"
                :readonly="!edit"
                :items="typesRemittent"
                :label="
                  $t('action.actions.select', {
                    field: $tc('fields.notifications.typeRemittent'),
                  }) + ' (*)'
                "
                :data-vv-name="$tc('fields.notifications.typeRemittent')"
                :error-messages="
                  errors.collect($tc('fields.notifications.typeRemittent'))
                "
                :clearable="edit"
                :loading="loading"
                @change="onChangeTypeRemittent"
              />
            </v-flex>
            <v-flex v-else md6 xs12 px-2>
              <v-autocomplete
                v-model="notification.typeRemittent"
                v-validate="'required'"
                :readonly="!edit"
                :items="typesRemittent"
                :label="
                  $t('action.actions.select', {
                    field: $tc('fields.notifications.typeRemittent'),
                  }) + ' (*)'
                "
                :data-vv-name="$tc('fields.notifications.typeRemittent')"
                :error-messages="
                  errors.collect($tc('fields.notifications.typeRemittent'))
                "
                :clearable="edit"
                :loading="loading"
                @change="onChangeTypeRemittent"
              />
            </v-flex>
            <template>
              <v-flex
                v-if="notification.typeRemittent === 'entity'"
                md6
                xs12
                px-2
              >
                <entity-field
                  v-model="notification.remittent"
                  v-validate="'required'"
                  :label="
                    $t('action.actions.select', {
                      field: $tc('titles.notifications.remittent'),
                    }) + ' (*)'
                  "
                  :clearable="edit"
                  :data-vv-name="$tc('titles.notifications.remittent')"
                  :error-messages="
                    errors.collect($tc('titles.notifications.remittent'))
                  "
                />
              </v-flex>
              <v-flex
                v-else-if="notification.typeRemittent === 'team'"
                md6
                xs12
                px-2
              >
                <team-field
                  key="remittent"
                  v-model="notification.remittent"
                  v-validate="'required'"
                  :category-id="notification.categoryIdRemittent"
                  :tournament-id="notification.tournamentIdRemittent"
                  :label="
                    $t('action.actions.select', {
                      field: $tc('titles.notifications.remittent'),
                    }) + ' (*)'
                  "
                  :clearable="edit"
                  :data-vv-name="$tc('titles.notifications.remittent')"
                  :error-messages="
                    errors.collect($tc('titles.notifications.remittent'))
                  "
                />
              </v-flex>
              <v-flex
                v-else-if="notification.typeRemittent === 'user'"
                md6
                xs12
                px-2
              >
                <user-field
                  v-model="notification.remittent"
                  v-validate="'required'"
                  readonly
                  :label="
                    $t('action.actions.select', {
                      field: $t('titles.notifications.remittent'),
                    }) + ' (*)'
                  "
                  :clearable="edit"
                  :data-vv-name="$t('titles.notifications.remittent')"
                  :error-messages="
                    errors.collect($t('titles.notifications.remittent'))
                  "
                />
              </v-flex>
            </template>
          </v-layout>
          <v-layout row wrap>
            <v-flex md6 xs12 px-2>
              <v-autocomplete
                v-model="notification.typeReceiver"
                v-validate="'required'"
                :readonly="!edit || !!userId || !!teamId || !!entityId"
                :items="typesReceiver"
                :label="
                  $t('action.actions.select', {
                    field: $tc('fields.notifications.typeReceiver'),
                  }) + ' (*)'
                "
                :data-vv-name="$tc('fields.notifications.typeReceiver')"
                :error-messages="
                  errors.collect($tc('fields.notifications.typeReceiver'))
                "
                :clearable="edit && !userId && !teamId && !entityId"
                :loading="loading"
                @change="
                  notification.receiver = ''
                  receiver = []
                "
              />
            </v-flex>
            <v-flex
              v-if="
                notification.typeReceiver === 'entity' ||
                notification.typeReceiver === 'team' ||
                notification.typeReceiver === 'user'
              "
              md6
              xs12
              px-2
            >
              <v-autocomplete
                v-if="!userId && !teamId && !entityId"
                v-model="notification.typeRole"
                :readonly="!edit"
                :items="typesRole"
                multiple
                :label="
                  $t('action.actions.select', {
                    field: $tc('fields.notifications.typeRole'),
                  }) + ' (*)'
                "
                :clearable="edit"
                @change="onChangeTypeRole"
              />
            </v-flex>
            <template v-if="!notification._id">
              <!-- new -->
              <v-flex
                v-if="
                  !toAll &&
                  !toCustomers &&
                  !toNotCustomers &&
                  ((notification.typeReceiver === 'entity' &&
                    notification.typeRole.length) ||
                    entityId)
                "
                md6
                xs12
                px-2
              >
                <entity-field
                  v-show="!entityId"
                  ref="formEntityField"
                  v-model="notification.receiver"
                  v-validate="'required'"
                  :label="
                    $t('action.actions.select', {
                      field: $tc('titles.notifications.receiver'),
                    }) + ' (*)'
                  "
                  hide-items
                  :to-customers="toCustomers"
                  :multiple="true"
                  :readonly="!!entityId"
                  :clearable="edit && !entityId"
                  :data-vv-name="$tc('titles.notifications.receiver')"
                  :error-messages="
                    errors.collect($tc('titles.notifications.receiver'))
                  "
                  @changeObjects="onChangeObjects"
                />
              </v-flex>
              <v-flex
                v-if="
                  (notification.typeReceiver === 'entity' &&
                    notification.typeRole.length) ||
                  entityId
                "
                md6
                xs12
                px-2
              >
                <v-switch
                  :value="toCustomers"
                  :label="'All Customers'"
                  color="primary"
                  @change="(val) => settoCustomers({ customers: val })"
                />
                <v-switch
                  :value="toNotCustomers"
                  :label="'All Non-Customers'"
                  color="primary"
                  @change="(val) => settoCustomers({ notCustomers: val })"
                />
                <v-switch
                  :value="toAll"
                  :label="'All'"
                  color="primary"
                  @change="(val) => settoCustomers({ toAll: val })"
                />
              </v-flex>
              <v-flex
                v-else-if="
                  (notification.typeReceiver === 'team' &&
                    notification.typeRole.length) ||
                  teamId
                "
                md6
                xs12
                px-2
              >
                <team-field
                  v-show="!teamId"
                  key="receiver"
                  v-model="notification.receiver"
                  v-validate="'required'"
                  :category-id="notification.categoryIdReceiver"
                  hide-items
                  :tournament-id="notification.tournamentIdReceiver"
                  :multiple="true"
                  :label="
                    $t('action.actions.select', {
                      field: $tc('titles.notifications.receiver'),
                    }) + ' (*)'
                  "
                  :readonly="!!teamId"
                  :clearable="edit && !teamId"
                  :data-vv-name="$tc('titles.notifications.receiver')"
                  :error-messages="
                    errors.collect($tc('titles.notifications.receiver'))
                  "
                  @changeObjects="onChangeObjects"
                />
              </v-flex>
              <v-flex
                v-else-if="
                  (notification.typeReceiver === 'user' &&
                    notification.typeRole.length) ||
                  userId
                "
                md6
                xs12
                px-2
              >
                <user-field
                  v-show="!userId"
                  v-model="notification.receiver"
                  v-validate="'required'"
                  populate-entity
                  hide-items
                  :populate-team="
                    notification.typeRole.includes('player') ||
                    notification.typeRole.includes('familiar') ||
                    notification.typeRole.includes('trainer')
                  "
                  :type-role="notification.typeRole"
                  :multiple="true"
                  :label="
                    $t('action.actions.select', {
                      field: $tc('titles.notifications.receiver'),
                    }) + ' (*)'
                  "
                  :readonly="!!userId"
                  :clearable="edit && !userId"
                  :data-vv-name="$tc('titles.notifications.receiver')"
                  :error-messages="
                    errors.collect($tc('titles.notifications.receiver'))
                  "
                  @changeObjects="onChangeObjects"
                />
              </v-flex>
              <v-flex
                v-else-if="notification.typeReceiver === 'entityFollowers'"
                md6
                xs12
                px-2
              >
                <entity-field
                  v-model="notification.receiver"
                  v-validate="'required'"
                  :label="
                    $t('action.actions.select', {
                      field: $tc('models.entity'),
                    }) + ' (*)'
                  "
                  :multiple="true"
                  hide-items
                  :clearable="edit"
                  :data-vv-name="$tc('models.entity')"
                  :error-messages="errors.collect($tc('models.entity'))"
                  @changeObjects="onChangeObjects"
                />
              </v-flex>
              <v-flex
                v-else-if="notification.typeReceiver === 'teamFollowers'"
                md6
                xs12
                px-2
              >
                <team-field
                  key="receiver"
                  v-model="notification.receiver"
                  v-validate="'required'"
                  :category-id="notification.categoryIdReceiver"
                  :tournament-id="notification.tournamentIdReceiver"
                  :label="
                    $t('action.actions.select', {
                      field: $tc('models.team'),
                    }) + ' (*)'
                  "
                  :multiple="true"
                  hide-items
                  :clearable="edit"
                  :data-vv-name="$tc('models.team')"
                  :error-messages="errors.collect($tc('models.team'))"
                  @changeObjects="onChangeObjects"
                />
              </v-flex>
              <v-flex
                v-else-if="notification.typeReceiver === 'playerFollowers'"
                md6
                xs12
                px-2
              >
                <user-field
                  v-model="notification.receiver"
                  v-validate="'required'"
                  populate-entity
                  populate-team
                  hide-items
                  :multiple="true"
                  :type-role="'player'"
                  :label="
                    $t('action.actions.select', {
                      field: $tc('titles.global.player'),
                    }) + ' (*)'
                  "
                  :clearable="edit"
                  :data-vv-name="$tc('titles.global.player')"
                  :error-messages="errors.collect($tc('titles.global.player'))"
                  @changeObjects="onChangeObjects"
                />
              </v-flex>
              <v-flex
                v-else-if="notification.typeReceiver === 'category'"
                md6
                xs12
                px-2
              >
                <category-menu
                  :objects="receiver"
                  clearable
                  :label="
                    $t('action.actions.select', {
                      field: $tc('models.category'),
                    })
                  "
                  @changeObjects="onChangeObjects"
                />
              </v-flex>
              <v-flex v-if="notification.typeReceiver === 'all'" md6 xs12 px-2>
                <CountryField
                  v-model="notification.countryId"
                  clearable
                  :label="
                    $t('action.actions.select', {
                      field: $tc('models.country'),
                    })
                  "
                  autocomplete="new-text"
                  browser-autocomplete
                  @changeName="(val) => (country = val)"
                />
              </v-flex>
              <v-flex md3 xs6 px-2>
                <v-switch
                  :value="notification.type === 'system'"
                  :label="$t('fields.notifications.type.system')"
                  color="primary"
                  @change="onChangeType"
                />
              </v-flex>
            </template>
          </v-layout>
          <ReceiverList
            v-if="receiver.length && !toAll && !toCustomers && !toNotCustomers"
            :type-receiver="notification.typeReceiver"
            :items="receiver"
            :actions="!userId && !teamId && !entityId"
            class="mb-3"
            @delete="deleteReceiver"
          />
          <v-layout row wrap>
            <v-flex v-if="notification.sendType.includes('email')" xs12 px-2>
              <S3Uploader
                v-if="dialog"
                :max-files="5"
                auto-upload
                @uploadSuccess="onUpload"
                @onFileRemoved="onFileRemoved"
              />
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <span style="color: red">(*) &nbsp;</span>
        <span>{{ $t('action.messages.fieldRequired') }}</span>
        <v-spacer />
        <meta-button
          v-if="!userId && !teamId && !entityId"
          type="reset"
          :disabled="loading"
          @click="clear"
        />
        <meta-button
          v-if="!notification._id"
          type="create"
          :loading="loading"
          @click="submit()"
        />
        <meta-button
          v-else
          type="update"
          :loading="loading"
          @click="submit()"
        />
        <meta-button type="cancel" @click="cancel" />
      </v-card-actions>
    </v-card>
    <DialogReceiversCount
      v-model="dialogReceiversCount"
      :count="count"
      :country="country"
      :send-date="datetime"
      :type="notification.type"
      @submit="submit(true)"
    />
  </v-dialog>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import DialogReceiversCount from './DialogReceiversCount.vue'
import ReceiverList from './ReceiverList.vue'
import CategoryMenu from '@/components/management/categories/CategoryMenu'
import CountryField from '@/components/widgets/Input/CountryField'
import EntityField from '@/components/widgets/Input/EntityField.vue'
import S3Uploader from '@/components/widgets/Input/S3Uploader.vue'
import TeamField from '@/components/widgets/Input/TeamField'
import TranslationField from '@/components/widgets/Input/TranslationField'
import UserField from '@/components/widgets/Input/UserField'
import { apiAxios } from '@/helpers'
import { parseObject } from '@/helpers/utils'
// import StepInformation from './StepInformation'

export default {
  name: 'NotificationForm',
  components: {
    TranslationField,
    TeamField,
    EntityField,
    UserField,
    ReceiverList,
    CategoryMenu,
    S3Uploader,
    CountryField,
    DialogReceiversCount,
  },
  props: {
    dialog: {
      type: Boolean,
      default: false,
      required: true,
    },
    edit: {
      type: Boolean,
      default: true,
      required: false,
    },
    userId: { type: String },
    teamId: { type: String },
    entityId: { type: String },
  },
  data() {
    return {
      notification: {},
      icon: '',
      file: '',
      titleFile: '',
      menuDate: false,
      datetime: new Date(),
      receiver: [],
      country: '',
      count: { push: 0, email: 0 },
      dialogReceiversCount: false,
      toCustomers: false,
      toNotCustomers: false,
      toAll: false,
    }
  },
  watch: {
    dialog(val) {
      if (!val) this.cancel()
      if (!this.selected || !this.selected.sendDate) {
        this.datetime = new Date()
      }
    },
    selected: {
      handler: function (val) {
        if (val) this.notification = parseObject(val)
        if (this.userId) {
          this.notification.typeReceiver = 'user'
          this.notification.receiver = [this.userId]
        }
        if (this.teamId) {
          this.notification.typeReceiver = 'team'
          this.notification.receiver = [this.teamId]
        }
        if (this.entityId) {
          this.notification.typeReceiver = 'entity'
          this.notification.receiver = [this.entityId]
        }
        this.notification.title = val.title
        this.notification.text = val.text
        if (this.notification._id) {
          this.datetime = new Date(this.notification.sendDate)
        }
      },
      immediate: true,
      deep: true,
    },
    // 'notification.receiver': {
    //   handler: function(val) {
    //     if (
    //       val &&
    //       !this.notification.categoryIdReceiver &&
    //       this.notification.typeReceiver === 'team'
    //     ) {
    //       this.$store.dispatch('teams/getOne', val).then(team => {
    //         if (team.categoryId)
    //           this.notification.categoryIdReceiver =
    //             team.categoryId._id || team.categoryId.id
    //       })
    //     }
    //   },
    //   immediate: true,
    //   deep: true
    // },
    'notification.remittent': {
      handler: function (val) {
        if (
          val &&
          !this.notification.categoryIdRemittent &&
          this.notification.typeRemittent === 'team'
        ) {
          this.$store.dispatch('teams/getOne', val).then((team) => {
            if (team.categoryId)
              this.notification.categoryIdRemittent =
                team.categoryId._id || team.categoryId.id
          })
        }
      },
      immediate: true,
      deep: true,
    },
    // 'notification.teamFollowers': {
    //   handler: function(val) {
    //     if (
    //       val &&
    //       !this.notification.categoryIdTeamFollowers &&
    //       this.notification.typeReceiver === 'teamFollowers'
    //     ) {
    //       this.$store.dispatch('teams/getOne', val).then(team => {
    //         if (team.categoryId)
    //           this.notification.categoryIdTeamFollowers =
    //             team.categoryIdReceiver._id || team.categoryId.id
    //       })
    //     }
    //   },
    //   immediate: true,
    //   deep: true
    // },
    'notification.icon': {
      handler: function (val) {
        if (val) {
          if (val.includes('http')) this.icon = val
          else this.icon = this.defaultValues.iconURL + val
        } else {
          this.icon = ''
        }

        this.titleFile = val
        this.file = ''
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    this.datetime = new Date()
    this.notification = parseObject(this.selected)
    this.notification.title = this.selected.title
    if (this.userId) {
      this.notification.typeReceiver = 'user'
      this.notification.receiver = [this.userId]
    }
    if (this.teamId) {
      this.notification.typeReceiver = 'team'
      this.notification.receiver = [this.teamId]
    }
    if (this.entityId) {
      this.notification.typeReceiver = 'entity'
      this.notification.receiver = [this.entityId]
    }
  },
  computed: {
    ...mapState({
      selected: (state) => state.notifications.selected,
      loading: (state) => state.notifications.loading,
    }),
    ...mapGetters({
      typesRemittent: 'notifications/typesRemittent',
      typesRemittentNoAdmin: 'notifications/typesRemittentNoAdmin',
      typesReceiver: 'notifications/typesReceiver',
      types: 'notifications/types',
      typesRole: 'notifications/typesRole',
    }),
    sendTypes() {
      return [
        {
          value: 'push',
          text: this.$t('fields.notifications.sendTypes.push'),
        },
        {
          value: 'email',
          text: this.$t('fields.notifications.sendTypes.email'),
        },
      ]
    },
    localTeam: {
      get() {
        return this.team
      },
    },
  },
  methods: {
    ...mapActions({
      setCreate: 'notifications/create',
      setUpdate: 'notifications/update',
      reset: 'notifications/reset',
    }),
    cancel() {
      this.$emit('close')
      this.beforeDestroy()
      setTimeout(() => {
        this.clear()
      }, 1000)
    },
    settoCustomers(config) {
      if (config.customers) {
        this.toCustomers = true
        this.toNotCustomers = false
        this.toAll = false
      } else if (config.notCustomers) {
        this.toAll = false
        this.toNotCustomers = true
        this.toCustomers = false
      } else if (config.toAll) {
        this.toAll = true
        this.toNotCustomers = false
        this.toCustomers = false
      } else {
        this.toAll = false
        this.toNotCustomers = false
        this.toCustomers = false
      }
    },
    onChangeObjects(items) {
      if (this.receiver.length === 0) {
        this.receiver = items
      } else {
        items.forEach((item) => {
          if (this.receiver.find((_item) => _item.value === item.value)) {
          } else {
            this.receiver.push(item)
          }
        })
      }
    },
    deleteReceiver(value) {
      if (this.notification.receiver) {
        this.notification.receiver = this.notification.receiver.filter(
          (item) => item != value
        )
      }
      this.receiver = this.receiver.filter((item) => item.value != value)
    },
    beforeDestroy() {
      this.$validator.pause()
    },
    clear() {
      this.$nextTick(() => {
        this.receiver = []
        this.icon = ''
        this.datetime = new Date()
        this.reset()
        this.$validator.reset()
      })
    },
    async getReceiversCount() {
      const { data } = await apiAxios.post(
        'notifications/receivers-count',
        this.notification
      )
      this.count = data.data
    },
    submit(force) {
      this.validate().then((valid) => {
        if (!valid) return
        let payload = Object.assign({}, this.notification)
        this.notification.sendDate = this.datetime

        if (!payload._id) {
          if (!this.notification.type) {
            this.notification.type = 'custom'
          }
          this.notification.all = false
          this.notification.customers = false
          this.notification.notCustomers = false
          if (!this.toAll && !this.toCustomers && !this.toNotCustomers)
            this.notification.receiver = this.receiver.map((item) => item.value)
          else {
            this.notification.receiver = ''
            if (this.toAll) this.notification.all = true
            if (this.toCustomers) this.notification.customers = true
            if (this.toNotCustomers) this.notification.notCustomers = true
          }
          if (force) {
            this.setCreate(this.notification).then(() => {
              this.cancel()
            })
          } else {
            this.getReceiversCount().then(() => {
              this.dialogReceiversCount = true
            })
          }
        } else {
          delete this.notification.receiver
          this.setUpdate(this.notification).then(() => {
            this.cancel()
          })
        }
      })
    },
    onChangeTypeRemittent(val) {
      if (val === 'user') {
        this.notification.remittent = this.$store.state.auth.user._id
      } else {
        this.notification.remittent = ''
      }
    },
    onChangeTypeRole() {
      if (this.notification.typeReceiver === 'user') {
        this.notification.receiver = ''
        this.receiver = ''
      }
    },
    onChangeTypeRoleUserPlay() {
      if (this.notification.typeReceiver === 'playerFollowers') {
        this.notification.receiver = ''
        this.receiver = ''
      }
    },
    onChangeType(value) {
      this.notification.type = value ? 'system' : 'custom'
    },
    onUpload(item) {
      this.notification.attachments.push(item)
    },
    onFileRemoved(filename) {
      this.notification.attachments = this.notification.attachments.filter(
        (item) => !item.includes(filename)
      )
    },
  },
}
</script>
